import { StoreAction } from '@shared/store/store-action.model';
import { StoreActionError } from '@shared/store/store-action-error.model';

import { LoginApiPayload } from '../models/login-api.model';

const LOGIN_SCOPE = '[Login]';
const API_SCOPE = `${ LOGIN_SCOPE } API`;

export namespace LoginActions {

  export class Login extends StoreAction<LoginApiPayload> {
    static override readonly type = `${ API_SCOPE } Login`;

    constructor(public override payload: LoginApiPayload) {
      super(payload);
    }
  }

  export class LoginSuccess extends StoreAction {
    static override readonly type = `${ API_SCOPE } Login Success`;
  }

  export class LoginFailed extends StoreActionError {
    static override readonly type = `${ API_SCOPE } Login Failed`;
  }

  export class ResetLoadedState extends StoreAction {
    static override readonly type = `${ LOGIN_SCOPE } Reset Loaded State`;
  }

  export class ResetState extends StoreAction {
    static override readonly type = `${ LOGIN_SCOPE } Reset State`;
  }
}
